/* global angular:false */

(function () {
    "use strict";

    angular.module("vendd")
        .controller('CheckoutCommentsController', function ($scope, $q, $element, ControlService, CommonUtils, Validation) {

            $scope.Model = $scope.Model || {};
            $scope.Control = $scope.Control || {};

            $scope.Control.Form = {};

            var controlName = 'Comments';
            $scope.registerControl(controlName, $element.get(0));

            var savedData = new SavedDataState();

            var applyChanges = function () {
                var deferred = $q.defer();
                ControlService.invokeCheckout($scope, $element, 'SetComments', $scope.Control.Form.Comments).then(function (response) {
                    $scope.setControlValue(controlName, $scope.Control.Form);
                    deferred.resolve(response);
                    $scope.Control.Loading = false;
                }, function (error) {
                    deferred.reject(error);
                    $scope.Control.Loading = false;
                });
                return deferred.promise;
            };

            $scope.Control.applyChanges = function () {

                if (!savedData.hasChanged($scope.Control.Form))
                    return;

                $scope.Control.Loading = true;
                applyChanges().then(function (response) {
                    $scope.setControlValue(controlName, $scope.Control.Form);
                    savedData.setData($scope.Control.Form);
                    $scope['Order'].Current.Comments = $scope.Control.Form.Comments;
                }, function (error) {
                    $scope.Control.Loading = false;
                    throw error;
                });
            };

            $element.get(0).set = function () {
                var deferred = $q.defer();

                ControlService.invokeCheckout($scope, $element, 'SetComments', $scope.Control.Form.Comments).then(function (response) {
                    $scope.setControlValue(controlName, $scope.Control.Form);
                    deferred.resolve(response);
                    $scope.Control.Loading = false;
                }, function (error) {
                    deferred.reject(error);
                    $scope.Control.Loading = false;
                });

                return deferred.promise;
            };

            ControlService.getCheckoutData("GetCommentsData", $scope, $element).then(function (response) {
                $scope.Model = {};
                angular.extend($scope.Model, response);

                if ($scope['Order'] &&
                    $scope['Order'].Current &&
                    $scope['Order'].Current.Comments) {

                    $scope.Control.Form.Comments = $scope['Order'].Current.Comments;
                }

                $scope.setControlValue(controlName, $scope.Control.Form);

                savedData.setData($scope.Control.Form);

                $scope.Control.Loading = false;

            }, function (error) {
                $scope.Control.Loading = false;
                throw error;
            });

        });
})();